export default function initAccessibility() {
  mouseDetector();
  // centerFocusedElement();
}

export function mouseDetector() {
  addEventListener('mousedown', function () {
    document.body.classList.add('using-mouse');
  });

  addEventListener('mouseup', function () {
    document.body.classList.add('using-mouse');
  });

  addEventListener('keydown', function () {
    document.body.classList.remove('using-mouse');
  });

  addEventListener('keyup', function () {
    document.body.classList.remove('using-mouse');
  });
}

function centerFocusedElement() {
  document.addEventListener('keydown', ev => {
    if (ev.key.toLowerCase() === 'tab') {
      const checkVisible = (elm) => {
        var rect = elm.getBoundingClientRect();
        var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
      };
      const _scroll = () => {
        const el = document.activeElement;
        if (!checkVisible(el)) {
          el.scrollIntoView({
            block: "center",
            behavior: "smooth",
          });
        }
      };

      setTimeout(_scroll,1);
    }
  });
}
